import axios from "axios";
import "../../App.css";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
/* import { Button } from "react-bootstrap";
 */ import { BASE_URL, getGlobalVar, setGlobalVar } from "../config/Config";
import Header from "../../components/Header";

import { Space, Table, Tag, Popconfirm, Tooltip, Button, message } from "antd";
import { render } from "@testing-library/react";
import { getProduct, updateProduct } from "../../repository/productApi";
import BarcodeModal from "../../components/Products/BarcodeModal";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const Products = () => {
  // URLS
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = auth?.org;

  const baseUrl = BASE_URL;
  const categoriesUrl = "/accountingapi/GetProductCategories/";
  const productsUrl = "/accountingapi/GetProduct/";
  const imgUrl = "";

  const [globalVar, setValue] = useState(getGlobalVar());
  const [products, setProducts] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [saleprice, setSalePrice] = useState("");
  const [editMode, setEditMode] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${baseUrl + categoriesUrl}?org=${org}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        //console.log(res.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${baseUrl + categoriesUrl}?org=${org}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      })
      .then((res) => {
        //console.log(res.data);
      });
  }, []);

  useEffect(() => {
    getProduct().then((res) => {
      //console.log(res);
      const fetchedProducts = res.map((product) => ({
        ...product,
        Photo: `${imgUrl}${product.Photo}`, // Prepend the base URL for images
      }));
      setProducts(fetchedProducts);
      //console.log(fetchedProducts);
    });
  }, []);

  const onCreateFormSubmit = (e) => {
    e.preventDefault();
    let productObj = {
      ProductName: productName,
      Price: price,
      SalesPrice: saleprice,
    };
  };

  const handleEdit = (record) => {
    navigate("/pos/editProduct", {
      state: { data: record, editMode: true },
    });
  };
  const handleDelete = async (id) => {
    try {
      const response = await updateProduct(id, { is_archive: true });
      setProducts((prevProducts) =>
        prevProducts.filter((product) => product.id !== id),
      );
      message.success("Product deleted successfully");
    } catch (error) {
      message.error("Failed to delete product");
    }
  };

  const handleDeleteAll = async () => {
    try {
      await Promise.all(
        products.map((p) => updateProduct(p.id, { is_archive: true })),
      );
      setProducts([]);
      message.success("All products deleted successfully");
    } catch (error) {
      message.error("Failed to delete all products");
    }
  };

  //console.log(price, saleprice, price);
  // {product.ProductCategories}
  // {product.Cost}
  // {product.SalesPrice}
  // {product.ProductType}

  const columns = [
    {
      title: "Image",
      key: "image",
      render: (_, product) => (
        <Space size="middle">
          <img
            src={product.Photo}
            alt="Product"
            style={{
              width: "100%",
              maxWidth: "80px", // adjust based on your table layout
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </Space>
      ),
    },
    {
      title: "Name",
      dataIndex: "ProductName",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Bar Code",
      dataIndex: "BarCode",
      key: "age",
    },
    {
      title: "Product Category",
      dataIndex: "ProductCategories",
      key: "ProductCategories",
    },
    {
      title: "Cost",
      dataIndex: "Cost",
      key: "Cost",
    },
    {
      title: "Sales Price",
      dataIndex: "SalesPrice",
      key: "SalesPrice",
    },
    {
      title: "Product Type",
      dataIndex: "ProductType",
      key: "ProductType",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          {/* Edit Button */}
          <Tooltip title="Edit Product">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>

          {/* Delete Button with confirmation */}
          <Tooltip title="Delete Product">
            <Popconfirm
              title="Are you sure you want to delete this product?"
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger size="small" icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>

          {/* Barcode Modal Trigger */}
          <BarcodeModal item={record} />
        </Space>
      ),
    },
  ];

  // {
  //   title: 'Tags',
  //   key: 'tags',
  //   dataIndex: 'tags',
  //   render: (_, { tags }) => (
  //     <>
  //       {tags.map((tag) => {
  //         let color = tag.length > 5 ? 'geekblue' : 'green';
  //         if (tag === 'loser') {
  //           color = 'volcano';
  //         }
  //         return (
  //           <Tag color={color} key={tag}>
  //             {tag.toUpperCase()}
  //           </Tag>
  //         );
  //       })}
  //     </>
  //   ),
  // }
  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div
        style={{
          flex: "11 11 100%",
          padding: "20px",
          marginTop: "64px",
          minWidth: 0,
          overflow: "auto",
        }}
      >
        <div className="row ">
          <div className=" col-12">
            <div className="row">
              <div className="col-6">
                <h1 className="text-2xl font-bold">Products</h1>
              </div>
              <div
                className="col-6 "
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                {/* <Popconfirm
                  title="Delete all products?"
                  description="This will archive all products and cannot be undone easily."
                  onConfirm={handleDeleteAll}
                  okText="Yes, delete all"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true }}
                  disabled={products.length === 0}
                >
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    disabled={products.length === 0}
                  >
                    Delete All
                  </Button>
                </Popconfirm> */}
                <Button
                  className="btn  xb"
                  onClick={() => navigate("/pos/addProduct")}
                >
                  Add Products
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table
              columns={columns}
              dataSource={products}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Products;
